﻿function setCorrectImageSources() {

    // Responsive carousel

    $(".carousel").each(function (callback, carousel) {

        // Check if re-sizing is needed
        var oldWidth = $(carousel).attr("data-width");
        var width = $(carousel).width();
        var resizeCount = imageSourceGetReziseCount(carousel);
        if (imageSourceCheckIfResizeBlocked(width, oldWidth, resizeCount)) {
            return;
        }
        $(carousel).attr("data-width", width);
        $(carousel).attr("data-resizecount", ++resizeCount);

        // Set aspect ratio if defined
        var height = 0;
        if (!!$(carousel).attr("data-aspect-ratio")) {
            var aspectRatio = $(carousel).attr("data-aspect-ratio").split(":");
            height = Math.floor((width / aspectRatio[0]) * aspectRatio[1]);
        }

        // Set image sources
        $(carousel).find("img[data-CarouselSrc]").each(function (callback, image) {
            var url = $(image).attr("data-CarouselSrc");
            var imageHeight = height <= 0 ? "" : "/" + height + "/Crop";
            $(image).attr("src", url + "/" + width + imageHeight);
        });

    });


    // Responsive images

    $("img[data-src]").each(function (callback, image) {
        var width = $(image.parentElement).width();
        var slideName = $(image).attr("data-slidename");
        if (slideName !== undefined) {
            // Dette er et slideshow, så vi hente størrelsen længere ude..
            width = $("#" + slideName).width();
        }
        var oldWidth = $(image).attr("data-size");
        var resizeCount = imageSourceGetReziseCount(image);
        if (imageSourceCheckIfResizeBlocked(width, oldWidth, resizeCount)) {
            return;
        }
        $(image).attr("data-size", width);
        $(image).attr("data-resizecount", resizeCount + 1);

        var url = $(image).attr("data-src");
        $(image).attr("src", url + "/" + width);
    });

}

function imageSourceGetReziseCount(container) {
    var resizeCount = $(container).attr("data-resizecount");
    if (resizeCount === undefined) {
        resizeCount = 0;
    } else {
        resizeCount = parseInt(resizeCount);
    }
    return resizeCount;
};

function imageSourceCheckIfResizeBlocked(width, oldWidth, resizeCount) {
    return width <= oldWidth || resizeCount >= 3;
}

$(function () {
    setCorrectImageSources();
    $(window).resize(function () {
        setCorrectImageSources();
    });
});